import Cart from '@/components/order/Cart'
	import loading from '@/components/order/loading'
	import newCustomer from '@/components/order/NewCustomer'
	import Feedback from '@/components/common/Feedback'
	import PromoCode from "@/components/order/PromoCode";
	import {
		ssoUrl,
		baseUrl,
		cvoUrl
	} from '@/config/env'
	import util from '@/config/util'
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex'
	import {
	cartInfoMethods,userInfoOrderMethods
} from "@/components/common/mixin";
	export default {
		data() {
			return {
				hoverActive: -1,
				subMenus:[], // 三級菜單
				subMenus1:[], //四級菜單
				loadProductNumber: 0,
				showTypeLoad: false,
				lrpName:{'LRPT2':'LRP Kit2','LRPT1':'LRP Kit1'},
				keys:'',
				newValue:false,
				showModal:false,
				showServiceModal:false,
				modalContent:{},
				serviceUrl:null,
				showFeedbackModal:false,
				showDrawer:false,
				activeCode:'',

				PromoModel: null,
				PromoModelShow: false,
				PromoModelType:null
			}
		},
		props: {
			menus:{
				type:Array,
				default:[],
			},
			customer: {
				type: Boolean,
				default: false
			},

		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {},
		watch: {
			hoverActive: function(value) {
				if (value == 'WSFT_Product') {
					this.loadProduct();
				}
			},
			customer:function(value){
				if(value){
					this.showCustomer()
				}
			},
			$route(value){
				this.hoverActive = -1
			}

		},
		mixins: [cartInfoMethods,userInfoOrderMethods],
		components: {
			Cart,
			loading,
			newCustomer,
			Feedback,
			PromoCode
		},
		computed: {
			...mapGetters(["getAccessToken", "getVipNo"]),
			...mapState({
				productInfo: state => state.order.productInfo,
				token: state => state.common.userToken,
				userInfo: state => state.common.wechatUserInfo,
				cartInfo: state => state.order.cartInfo,

			}),
			isMobile(){
				if (document.body.clientWidth <= 768) {
					return true
				}
				return false
			},
			userlevel(){
				return this.userInfo?.value?.binding?.customer_type || "Guest"
			},
			isLogin(){
				return this.userInfo?.value
			},
			
			typeList:function(){
				if(this.productInfo && this.productInfo.value){
					return this.productInfo.value||[];
				}
				return [];
			},
			leftMenus(){
				return this.menus.filter(item=>item.MenuFlag == 10)
			},
			rightMenus(){
				console.log(this.menus.filter(item=>item.MenuFlag == 11))
				return this.menus.filter(item=>item.MenuFlag == 11&&item.Code=='WSFT_Shopcart')
			},
			activeIndex(){
				let code = this.$route.meta.code;
				
				return code
				// for (let index in this.rightMenus) {
				// 	let item = this.rightMenus[index]
				// 	if (item.Code == code) return index
				// }
			},
			// activeCode(){
			// 	let code = this.$route.meta.code;
			// 	return code
			// },
			serviceHeight(){
				return window.screen.availHeight - 350
			}
		},
		methods: {
			...mapActions([
				'getBrandMenusAction', 'initProductAction','getCommunityArticleAction','logOutAction'
			]),
			select(name){
				console.log(name)
			},
			async initData() {
				console.log(this.userInfo)
				this.keys = this.$route.path == '/show/search' ? this.$route.query.keys:''
			},
			checkPermission(roleCode){
				roleCode = roleCode?.toLowerCase()
				if (!roleCode) return true
				if (roleCode == "lrp2"||roleCode == "lrp1") {
					return this.newcustomer;
				}
				let userlevel = this.userlevel.toLowerCase()
				if (roleCode.indexOf(userlevel) != -1) return true
				return false
			},
			async showService(){
				window.postMessage({action:'showService'},'*')
			},
			trigerDrawer(){
				this.showDrawer=true
				this.activeCode = this.$route.meta.code;
			},
			showCustomer(){
				this.hoverActive=-1;
				this.newValue=true;
			},
			close(){
				this.newValue=false;
				if(this.isMobile){
					this.$emit('colseCustomer');
				}
				
			},
			search(){
				if(this.isMobile&&this.$route.path=='/order/product'){
					this.$emit('search',this.keys);
					return 
				}
				this.$router.push({
					path:'/show/search',
					query:{
						keys:this.keys,
						random:util.guid()
					}
				})
			},
			async loadProduct() {
				if(this.loadProductNumber>=1){
					return 
				}
				this.loadProductNumber++;
				if (this.typeList[0]) {
					this.initProductAction();
				} else {
					this.showTypeLoad = true;
					await this.initProductAction();
					this.showTypeLoad = false;
				}
				//console.log('productInfo',this.productInfo)
			},
			dealwithType(item){
				this.$router.push('/order/product?type='+encodeURI(item.name_en));
			},
			href(item){	
				this.hoverActive = -1
				if(item.Code=='WSFT_Shopcart'){
					//移動版判斷
					if(!this.isMobile){
						return 
					}
					
				}
				let url = item.Href;
				if (this.token && url.indexOf('http') == 0 && url.indexOf(baseUrl) != 0) {
					url += `?token=${this.token}`;
				}
				if (url.indexOf('http') == 0) {
					window.open(url);
				} else if(url.indexOf('action://') == 0){
					let actionUrl = url.split('action://')[1]
					console.log(actionUrl)
					let [action, ...query] = actionUrl.split('?');
					query = query.join('?')
					let queryObj = {}
					if (query) {
						let queryArray = query.split('&')
						queryArray.forEach(item => {
								let [key, ...value] = item.split('=')
								queryObj[key] = value.join('=')
						});
					}
					this[action]&&this[action](queryObj)

				} else {
					location = url
				}
				this.hoverActive=-1;
				this.showDrawer = false
			},
			async showArticle({Code}){
				this.modalContent = await this.getCommunityArticleAction({Code})
				this.showModal = true
			},
			showFeedback(){
				this.showFeedbackModal = true
			},
			goReg(){
				location = `${cvoUrl}/vo/index.html#/enroll/start`
			},
			goOrder(){
				this.$router.push('/order/orders');
				//location = `${cvoUrl}/vo/index.html#/wxorders?token=${this.getAccessToken}&source=WebSite`
			},
			showNewTips() {
				//this.showNewCustomer=true;
				this.$router.push('/order/cart');
			},
			logout(){
				this.logOutAction(this.token).then(()=>{
					location.reload()
				})
			},
			showPromoCode(products,type) {
				if (products) {
					this.PromoModel = products;
					this.PromoModelType=type
				}
				this.PromoModelShow = !this.PromoModelShow;
			},
			next(){
				console.log('222222')
				this.hoverActive=-1;
			},
			goUrl(url){
				this.$router.push(url);
			}
			
		},
	}